module.exports = __webpack_public_path__ + "static/media/game_cover_penguin@768.aa5a1e4b.png";